<template>
  <div class="main-content">
    <div class="center-body">
      <Nav />

      <!-- 第一层（替换后的“专注行业解决方案”板块） -->
      <div class="row"
        style="position: relative; text-align: center; padding: 120px 0px 120px; background: #f8faff;background: linear-gradient(86deg, #c1e4fd75, transparent);">
        <div style="max-width: 1200px; margin: 0 auto;">
          <!-- 标题区域（带边框） -->
          <div style="display: inline-block; padding: 60px 0px;border-radius: 4px; margin-bottom: 20px;">
            <div style="font-size: 44px; font-weight: 400; color: #333; line-height: 1.4;">
              专注行业解决方案，助力企业<br>数字化转型
            </div>
          </div>

          <!-- 描述文本 -->
          <div style="font-size: 14px; color: #666; line-height: 22px; max-width: 800px; margin: 0 auto 40px;">
            我们是一家专注于智慧燃气、智慧水务及工业制造MES领域的领先软件提供商。我们以深刻的行业洞察和先进的软件技术，为客户提供从智能终端到整体解决方案的全方位服务，致力于通过数字化转型，助力客户提升运营安全、优化生产效率、实现可持续发展。
          </div>

          <!-- 数据卡片区域 -->
          <div style="display: flex; justify-content: center; gap: 60px; margin-bottom: 60px;">
            <!-- 公司成立 -->
            <div
              style="width: 300px; padding: 40px 25px; background: #ffffffab; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); text-align: center; transition: all 0.3s ease;">
              <div style="font-size: 48px; font-weight: bold; color: #409eff; margin-bottom: 12px;">2016</div>
              <div style="font-size: 16px; color: #333; font-weight: 500;">公司成立</div>
            </div>

            <!-- 行业解决方案 -->
            <div
              style="width: 300px; padding: 40px 25px; background: #ffffffab; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); text-align: center; transition: all 0.3s ease;">
              <div style="font-size: 48px; font-weight: bold; color: #409eff; margin-bottom: 12px;">50+</div>
              <div style="font-size: 16px; color: #333; font-weight: 500;">行业解决方案</div>
            </div>

            <!-- 企业客户 -->
            <div
              style="width: 300px; padding: 40px 25px; background: #ffffffab; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); text-align: center; transition: all 0.3s ease;">
              <div style="font-size: 48px; font-weight: bold; color: #409eff; margin-bottom: 12px;">600+</div>
              <div style="font-size: 16px; color: #333; font-weight: 500;">企业客户</div>
            </div>
          </div>

          <!-- 我们的能力区域 -->
          <div>
            <div style="font-size: 44px; font-weight: 400; color: #333; margin-bottom: 45px;">我们的能力</div>
            <div style="font-size: 14px; color: #666; line-height: 22px; max-width: 800px; margin: 0 auto;">
              拥有10余年技术沉淀，目前已成为能向国内外提供多种具有高新技术含量的专业软件公司。以客户为中心，在全国建立销售服务网络，共有销售和服务团队200余人，为客户提供快速、优质的服务响应。
            </div>
          </div>
        </div>
      </div>

      <!-- 第二层（企业简介板块） -->
      <div style="background: linear-gradient(274deg, #607d8b21, transparent);padding: 100px 0;">
        <div style="margin: 0px auto; width: 1200px; padding: 40px; border-radius: 8px; ">
          <!-- 标题区域 -->
          <div style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 85px;text-align: center;">
            企业简介
          </div>
          <!-- <div class="row ju-c al-c" style="color: #999; font-size: 14px; margin-bottom: 30px;">
    内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容
  </div> -->

          <!-- 内容区域（左侧图片+右侧文字） -->
          <div style="display: flex; gap: 40px; align-items: flex-start;">
            <!-- 左侧图片 -->
            <div style="width: 40%;">
              <img src="../../assets/img/gywmImg2.png" style="width: 100%; border-radius: 8px; object-fit: cover;" />

              <!-- 愿景/目标区域 -->
              <div style="margin-top: 20px;">
                <div style="font-size: 18px; font-weight: 600; color: #333; margin-bottom: 8px;">我们的愿景</div>
                <div style="font-size: 14px; color: #666; line-height: 22px;">
                  通过深度数字化让能源流动与工业生产更安全、高效与可持续。
                </div>

                <div style="font-size: 18px; font-weight: 600; color: #333; margin-top: 20px; margin-bottom: 8px;">我们的目标
                </div>
                <div style="font-size: 14px; color: #666; line-height: 22px;">
                  为客户交付可衡量的卓越价值：保障安全、提升效率、创造协同
                </div>
              </div>
            </div>

            <!-- 右侧文字内容 -->
            <div style="width: 60%; font-size: 24px; color: #666;">
              <p style="line-height: normal;text-indent: 2em;">
                上海贸宝信息技术有限公司(以下简称"贸宝信息")是上海真兰仪表科技股份有限公司旗下全资信息高新技术企业，成立于2016年，注册资金2000万元。公司依托德国米诺工业4.0核心技术，深耕智慧燃气、智慧水务及智能制造三大领域，为全球客户提供创新解决方案。
              </p>

              <p style="line-height: normal;margin-top: 26px;text-indent: 2em;">
                在燃气领域，公司构建了全场景数字化服务体系，自主研发物联网无线抄表系统、预付费管理系统、GIS管网智能巡检系统等核心产品，实现与支付宝、微信及银行系统的无缝对接。其分布式物联网监控技术和燃气运维APP已服务国内外600+家燃气企业，打造从计量终端到云端管理的完整生态。
              </p>

              <p style="line-height: normal;margin-top: 26px;text-indent: 2em;">
                面向水务行业，公司将成熟的管网监控技术和智能巡检系统延伸应用，涵盖采集计量、生产调度、管网监测、营销安全、客服抄表以及BIM等技术等方面，助力水务企业实现数字化运营，提升管网安全与服务质量。</p>

              <p style="line-height: normal;margin-top: 26px;text-indent: 2em;">
                在智能制造方面，公司推出OrBit系列工业软件平台，涵盖WES制造执行系统、WMS仓库管理系统及SCADA数据采集系统等核心模块，为制造企业提供从生产排程到运营管理的全流程数字化解决方案。该平台深度融合工业物联异构技术，已形成多项自主知识产权。
              </p>

              <p style="line-height: normal;margin-top: 26px;text-indent: 2em;">
                "做行业传承的艺术家"是公司追求的理念，奉行"至细至精至美"的设计理念，传承德国仪表严谨苛求的制造心态，公司以"专业"的行为理念，始终如一地从事计量行业系统的研发、制造与销售。</p>
            </div>

          </div>
        </div>
      </div>

      <!-- 第三层（核心优势板块） -->
      <div style="background: linear-gradient(86deg, #c1e4fd75, transparent);padding: 80px 0 120px;">
        <div style="margin: 0px auto; min-height: 60px; width: 1200px; text-align: center; padding: 40px 0;">
          <!-- 标题区域 -->
          <div style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 85px;text-align: center;">核心优势
          </div>

          <!-- 优势卡片区域 -->
          <div style="display: flex; justify-content: center; gap: 30px;">
            <!-- 行业深度 -->
            <div
              style="width: 360px; padding: 30px; background: #ffffffbd; border: 1px solid #eee; border-radius: 8px; text-align: left; transition: all 0.3s ease;">
              <div style="display: flex; align-items: center; margin-bottom: 15px;">
                <div
                  style="width: 32px; height: 32px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                  <!-- 可替换为实际图标 -->
                  <span style="color: #409eff;">📊</span>
                </div>
                <div style="font-size: 18px; font-weight: 600; color: #333;">行业深度</div>
              </div>
              <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
                深耕燃气、水务及制造领域，拥有深厚的业务理解与项目实践积累。
              </div>
              <div style="font-size: 14px; color: #409eff; font-weight: 500;">10多年深耕</div>
            </div>

            <!-- 全栈能力 -->
            <div
              style="width: 360px; padding: 30px; background: #ffffffbd; border: 1px solid #eee; border-radius: 8px; text-align: left; transition: all 0.3s ease;">
              <div style="display: flex; align-items: center; margin-bottom: 15px;">
                <div
                  style="width: 32px; height: 32px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                  <!-- 可替换为实际图标 -->
                  <span style="color: #409eff;">🔧</span>
                </div>
                <div style="font-size: 18px; font-weight: 600; color: #333;">全栈能力</div>
              </div>
              <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
                提供从感知层、平台软件到数据分析决策的全栈解决方案。
              </div>
              <div style="font-size: 14px; color: #409eff; font-weight: 500;">专业研发实力</div>
            </div>

            <!-- 持续服务 -->
            <div
              style="width: 360px; padding: 30px; background: #ffffffbd; border: 1px solid #eee; border-radius: 8px; text-align: left; transition: all 0.3s ease;">
              <div style="display: flex; align-items: center; margin-bottom: 15px;">
                <div
                  style="width: 32px; height: 32px; background: #e1f5ff; border-radius: 4px; display: flex; justify-content: center; align-items: center; margin-right: 12px;">
                  <!-- 可替换为实际图标 -->
                  <span style="color: #409eff;">📞</span>
                </div>
                <div style="font-size: 18px; font-weight: 600; color: #333;">持续服务</div>
              </div>
              <div style="font-size: 14px; color: #666; line-height: 22px; margin-bottom: 15px;">
                依托覆盖项目全生命周期的专业服务体系，保障客户成功与系统高效运行。
              </div>
              <div style="font-size: 14px; color: #409eff; font-weight: 500;">成功保障</div>
            </div>
          </div>
        </div>

      </div>

      <!-- 第四层（资质能力+优秀的团队板块） -->
      <div
        style="margin: 60px auto; min-height: 60px; width: 1200px; padding: 40px 0; text-align: center; background: #fff;">
        <!-- 资质能力区域 -->
        <div>
          <div style="color: #000; font-size: 44px; font-weight: 400; margin-bottom: 35px;text-align: center;">资质能力
          </div>
          <div style="font-size: 14px; color: #666; margin-bottom: 80px;">
            国家级高新技术企业、20余项软件著作权、CMMI5软件认证<br>
            专利等20项、ISO9001、ISO27001信息安全管理体系认证证书
          </div>
          <!-- 资质图片 -->
          <div style="width: 100%; max-width: 1800px; margin: 0 auto;">
            <img src="../../assets/img/zlindex80.png" style="width: 100%; border-radius: 8px;" />
          </div>
        </div>

        <!-- 优秀的团队区域 -->
        <!-- <div style="margin-top: 80px;">
    <div style="font-size: 32px; font-weight: bold; color: #333; margin-bottom: 10px;">优秀的团队</div>
    <div style="font-size: 14px; color: #666; margin-bottom: 40px;">
      懂业务、技术、实施、重服务的团队
    </div>

    <div style="display: flex; justify-content: center; gap: 30px;">

      <div style="width: 220px; text-align: center;">
        <div style="width: 100%; height: 180px; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
          <img src="../../assets/img/tdImg1.png" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        <div style="font-size: 16px; color: #333; font-weight: 500; padding: 8px 15px; border: 1px solid #e1e8ff; border-radius: 20px; display: inline-block;">
          资深的行业顾问
        </div>
      </div>
 
      <div style="width: 220px; text-align: center;">
        <div style="width: 100%; height: 180px; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
          <img src="../../assets/img/tdImg3.png" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        <div style="font-size: 16px; color: #333; font-weight: 500; padding: 8px 15px; border: 1px solid #e1e8ff; border-radius: 20px; display: inline-block;">
          专业的技术专家
        </div>
      </div>
  
      <div style="width: 220px; text-align: center;">
        <div style="width: 100%; height: 180px; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
          <img src="../../assets/img/tdImg2.png" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        <div style="font-size: 16px; color: #333; font-weight: 500; padding: 8px 15px; border: 1px solid #e1e8ff; border-radius: 20px; display: inline-block;">
          卓越的交付团队
        </div>
      </div>

      <div style="width: 220px; text-align: center;">
        <div style="width: 100%; height: 180px; border-radius: 8px; overflow: hidden; margin-bottom: 10px;">
          <img src="../../assets/img/tdImg4.png" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        <div style="font-size: 16px; color: #333; font-weight: 500; padding: 8px 15px; border: 1px solid #e1e8ff; border-radius: 20px; display: inline-block;">
          可靠的售后伙伴
        </div>
      </div>
    </div>
  </div> -->
      </div>

      <Foot />
    </div>
  </div>
</template>

<script>
import Nav from "./nav.vue";
import Foot from "./foot.vue";

export default {
  name: "App",
  components: {
    Nav,
    Foot
  },
  data() {
    return {
      curHeight: 0,
      index: 0
    };
  },
  watch: {
    windowHeight(val) {
      let that = this;
      console.log("实时屏幕高度：", val, that.windowHeight);
    },
  },
  beforeMount() {

    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.curHeight = h; //减去页面上固定高度height

  },
  methods: {
    enter(e) {
      this.index = e
    },
    leave() {
      this.index = 0
    }
  },
  mounted() {
    var that = this;
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        that.curHeight = window.fullHeight; // 高

      })()
    };
  },
};
</script>
<style scoped>
.main-content {
  min-height: 100%;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
  display: block;
  position: absolute;
  /* background: #f7f7f7; */
}

.prduct-box {
  width: 1200px;
  /* padding-top: 60px; */
  padding-bottom: 100px;
  margin: 0 auto;
}

.center-body {
  margin: 0 auto;
}

.fixed-bottom {
  position: fixed;
  bottom: 0;
}

.hxyx-box {
  height: 793px;
  background-image: url(../../assets/img/gywmbg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 80px;
  text-align: center;
}

.mfty-box {
  height: 600px;
  background-color: #fff;
  padding-top: 60px;
  text-align: center;
}

.active {
  color: #fff !important;
  background-color: #0070FD !important;
}
.info{
  line-height: auto!important;
}
</style>
